<div class="betslip-over-ask-review-timer" *ngIf="reviewOfferExpires">
    <i class="betslip-over-ask-review-timer__icon theme-clock"></i>
    <span
        class="betslip-over-ask-review-timer__time"
        [ngClass]="{ 'betslip-over-ask-review-timer__time--highlight': shouldHighlight }"
        [innerHTML]="reviewOfferExpires | msTrust: 'html'"></span>
</div>
